import React from 'react';
import './Pagination.css';

const Pagination = ({ pagination, onPageChange }) => {
  if (!pagination || pagination.total === 0 || pagination.pages <= 1) {
    return null;
  }

  const { page, pages, total, limit } = pagination;
  const startItem = ((page - 1) * limit) + 1;
  const endItem = Math.min(page * limit, total);

  return (
    <div className="dashboard-pagination">
      <div className="pagination-info">
        Showing {startItem}-{endItem} of {total}
      </div>

      <div className="pagination-controls">
        <button
          className="pagination-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(1)}
          title="First page"
        >
          &laquo;
        </button>
        <button
          className="pagination-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          title="Previous page"
        >
          &lsaquo; Prev
        </button>

        <span className="page-indicator">
          Page {page} of {pages}
        </span>

        <button
          className="pagination-btn"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          title="Next page"
        >
          Next &rsaquo;
        </button>
        <button
          className="pagination-btn"
          disabled={page >= pages}
          onClick={() => onPageChange(pages)}
          title="Last page"
        >
          &raquo;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
